import { mapValues } from 'lodash';
/**
 * Version 25 migrations registration summary widget - Air request
 * - Adding default configurations for air request on registration summary
 */
export default function v25(website) {
  return {
    ...website,
    eventVersion: 25,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary' && !layoutItem.config.airRequestInformation) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            airRequestInformation: {
              display: true,
              header: 'EventWidgets_AirRequest_WidgetTitle__resx'
            },
            style: {
              ...layoutItem.config.style,
              airRequestStyles: {
                sectionSubheaders: {
                  styleMapping: 'text1'
                },
                tableHeader: {
                  styleMapping: 'text2'
                },
                airportNames: {
                  styleMapping: 'text1'
                },
                flightClass: {
                  styleMapping: 'text2'
                },
                travelDates: {
                  styleMapping: 'text2'
                },
                itemBackground: {
                  styleMapping: 'custom',
                  background: {
                    image: null,
                    color: 'secondary',
                    borderRadius: 0
                  },
                  border: {
                    thickness: 0,
                    borderStyle: 'solid'
                  }
                },
                accent: {
                  styleMapping: 'custom',
                  background: {
                    image: null,
                    color: 'accent',
                    borderRadius: 0
                  },
                  border: {
                    thickness: 0,
                    borderStyle: 'solid'
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
